module.exports = __webpack_public_path__ + "img/kal-visuals-square.83531691.jpg";